module.exports = __webpack_public_path__ + "img/lk.9d68b2eb.svg";